// 首页tips
export const OPENLIST = 'OPENLIST'
export const DELLIST = 'DELLIST'
export const CHANGE = 'CHANGE'
export const CLEAR = 'CLEAR'
export const INIT = 'INIT'
// 规划咨询模块弹出
export const changeproposal = 'changeproposal'
export const changestudy = 'changestudy'
export const changeplan = 'changeplan'
// 投资管理弹出
export const changetouzi = 'changetouzi'
// 是否项目组成员
export const changeayth = 'changeayth'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js